import { DITypes } from "@/core/@types/types";
import { AsyncContainerModule } from "inversify";
import FinancasFeatureGatewayAdapter from "../services/adapters/FinancasFeatureGatewayAdapter";
import { IFinancasFeatureGateway } from "../services/ports/FinancasFeatureGateway";

export const financasFeaturesContainer = new AsyncContainerModule(
  async (bind) => {
    bind<IFinancasFeatureGateway>(DITypes.FINANCAS_FEATURES).to(
      FinancasFeatureGatewayAdapter
    );
  }
);
